import OrganizationVehicleTree from '@/models/OrganizationVehicleTree'
import OrganizationDeviceTreeTransformer from '@/transformers/OrganizationDeviceTreeTransformer'

export default class OrganizationVehicleTreeTransformer {
    constructor (organizationDeviceTreeTransformer = new OrganizationDeviceTreeTransformer()) {
        this.organizationDeviceTreeTransformer = organizationDeviceTreeTransformer
    }

    transform (data) {
        let vehicle = new OrganizationVehicleTree(
            data.id,
            data.level,
            data.name
        )

        if (data.device) {
            let deviceTransformed = this.organizationDeviceTreeTransformer.transform(data.device)
            deviceTransformed.setParent(vehicle)

            vehicle.setDevice(deviceTransformed)
        }


        return vehicle
    }
}
